import {
  EVENT_SET_CLIENT_USER,
  EventSetClientUserPayload,
} from '@weblite/ts-action/client-user'

import { serverSub } from '$func/subscription'
import { clientUserStorage } from './storage'

serverSub.subscribe(
  EVENT_SET_CLIENT_USER,
  ({ updatedFields }: EventSetClientUserPayload) =>
    clientUserStorage.set(updatedFields),
)
